<template>
  <RecordsCard
    :title="$t('recordsCard.driestMonths.title')"
    :subtitle="$t('recordsCard.driestMonths.subtitle')"
    :data="driestMonths"
    :options="{
      date: {
        year: 'numeric',
        month: 'short',
      },
      unit: 'in',
    }"
  />
</template>
<script setup lang="ts">
import RecordsCard from '~/components/RecordsCard.vue'
const props = defineProps({
      data: {
        required: true,
        type: Object,
      },
      summary: {
        required: false,
        type: Object,
        default: null
      },
      selectedMonth: {
        required: false,
        type: Number,
        default: null
      }
    })

const driestMonths = computed(() => {
  return props.data
      .select({ date: "title", totalPrecipitation: "value" })
      .objects();
});




</script>
<script lang="ts">
export default {
  name: 'DriestMonthsCard'
}
</script>